import { atom } from 'jotai';

import { remoteConfigAtom } from 'src/stores/auth/atoms';
import { isObjectKeyTrue } from 'src/utils/common';
import getDeviceInfo from 'src/utils/device/info';
import { getAtomWithStorage } from 'src/utils/localStorageUtils';

export enum CreatorOnboardingStep {
  Welcome,
  Guideline,
  Tutorials,
  Done,
}

// 크리에이터용 온보딩에 큰 변화가 생기면 key를 변경한다.
export const creatorOnboardingStepAtom = getAtomWithStorage(
  'currentCreatorOnboardingStep_v2',
  CreatorOnboardingStep.Welcome
);

export const defaultCreatorFilterAppliedAtom = getAtomWithStorage(
  'defaultCreatorFilterApplied',
  false
);

export const creatorSidebarExpandedAtom = getAtomWithStorage('creatorSidebarExpanded', true);

export const isCreatorModeAtom = atom((get) => {
  const { isMobile } = getDeviceInfo();
  if (isMobile) return false;

  const remoteConfig = get(remoteConfigAtom);
  return !!remoteConfig && isObjectKeyTrue(remoteConfig, 'enableCreatorPlan');
});
